export class UserPoolDto {
  id: string;
  name: string;
}
